module.exports = window["grappelli"];